import { render, staticRenderFns } from "./blog-review.vue?vue&type=template&id=eb697ff4&scoped=true"
import script from "./blog-review.vue?vue&type=script&lang=js"
export * from "./blog-review.vue?vue&type=script&lang=js"
import style0 from "./blog-review.vue?vue&type=style&index=0&id=eb697ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb697ff4",
  null
  
)

export default component.exports